export default "__VITE_ASSET__CuuskyaE__"